/* eslint-disable react-hooks/exhaustive-deps */

import { styled } from '@mui/material/styles';
import Scrollspy from 'react-scrollspy-ez';
import { memo } from 'react';

const MenuDetailDocument = memo(({ sections }) => {
  const ScrollspySwapper = styled('div')`
    position: relative;
    padding: 10px;
    height: 100%;
    /* padding-left: 20px; */

    .spyItemClass {
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.5;
      margin: 2px 0;
      padding: 7px 8px 7px 12px;
      border-radius: 0 5px 5px 0;
      color: #5e5e5e;
      transition: background-color 150ms ease, color 150ms ease, border-color 150ms ease;
    }

    .spyItemClass:hover {
      color: #14a8e4;
      font-weight: 600;
    }

    .spyItemClass.active {
      font-weight: 600;
      color: #14a8e4;
    }
  `;

  return (
    <ScrollspySwapper>
      <Scrollspy
        ids={sections?.map((item) => item?.id)}
        itemContainerClassName="scrollSpyContainer"
        activeItemClassName="active"
        itemClassName="spyItemClass"
        includeParentClasses
        offset={-200}
      />
    </ScrollspySwapper>
  );
});

export default MenuDetailDocument;
